export const UPLOADER_FEATURE_KEY = 'uploader';
